import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SampleAudioComponent from '@components/history/historyItem/body/tasks/values/sampleAudioComponent';
import AlertService from '@services/cm/Alert';
import NotificationComponent from '@src/helpers/_showNotifications';
import { Icon } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import React from 'react';

import ApiResponseDisplayer from '../components/ApiResponseDisplayer';
import FormBuilder from '../components/Form';
import Modal from '../components/Modal';
import ModalImageComponent from '../components/modals/image/ModelImageComponentCM';
import Page from '../components/Page';
import Table from '../components/TableComponent';
import { AlertEditForm, AlertForm, AlertSearchForm } from '../forms/Alert';
import I18n from '../i18n';
import { Alert as AlertInterface } from '../interfaces/cm/Alert';
import AppContext from '../services/Context';
import styled from '../styled-components';

const _service: AlertService = new AlertService();

type PropType = {};
type StateType = {
    isLoading: boolean;
    showFormModal: boolean;
    showImageModal: boolean;
    tableData: AlertInterface[];
    filteredTableData: AlertInterface[];
    editItem?: AlertInterface;
    serverResponse: any;
    fileList: any[],
    imageUpload: any;
    previewVisible:boolean;
    previewImage: string,
};

const tableColumns = [{
    title: 'table.alerts.name',
    dataIndex: 'name',
    key: 'name',
    width: '23%',
}, {
    title: 'table.alerts.audio',
    dataIndex: 'audio',
    key: 'audio',
}, {
    title: 'table.alerts.duration',
    dataIndex: 'duration',
    key: 'duration',

}, {
    title: 'table.alerts.image',
    dataIndex: 'photo',
    key: 'photo',
}, {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
    width: '20%',
}
];

class Alerts extends React.Component<PropType, StateType> {
    private idUnit: string = '';
    private allAlerts: any;

    state = {
        isLoading: false,
        showFormModal: false,
        showImageModal: false,
        tableData: [],
        filteredTableData: [],
        editItem: {
            id: '',
            name: '',
            text: '',
            duration: 0,
            imgData: undefined,
            imgUrl: ''
        },
        fileList: [],
        imageUpload: '',
        serverResponse: undefined,
        previewVisible: false,
        previewImage: '',
    };

    componentDidUpdate (){
        console.log('valor inicial do file', this.state.fileList)
    }

    setUnit(unitId: string) {
        console.log('set unit: ', unitId);
        this.idUnit = unitId;
    }

    componentDidMount() {
        this.getAlerts();
    }

    toggleFormModal = () =>
        this.setState({
            showFormModal: !this.state.showFormModal,
            serverResponse: undefined,
            editItem: {
                id: '',
                name: '',
                text: '',
                duration: 0,
                imgData: this.state.fileList[0]
            },
        });

    toggleShowImage = (id: string) => {
        const alert = this.getAlertById(id);
        this.setState({
            editItem: alert,
            showImageModal: !this.state.showImageModal
        })
    }

    getAlertById = (id: string) => {
        return this.allAlerts.filter((item: AlertInterface) => item.id == id)[0];
    }

    getAlerts = async () => {
        this.setState({ isLoading: true, showFormModal: false });
        try {
            const data: any = await _service.listAll(this.idUnit);
            this.allAlerts = data;
            console.log(data);

            const dataTableCreate: any = [];
            data.map((item: any) => {
                const playAudio = <div>
                    <SampleAudioComponent actionText={"@Tocar"} url={item.audioMaleUrl} />
                    <SampleAudioComponent actionText={"@Tocar"} url={item.audioFemaleUrl} />
                </div>;
                // let seeImage = <a onClick={() => this.toggleShowImage(item.id)}>Ver Imagem</a>;
                dataTableCreate.push({
                    id: item.id,
                    name: item.name,
                    audio: playAudio,
                    //audioGender: item.audioGender,
                    duration: item.duration,
                    photo: item.imgUrl,
                    action: true,
                })
                //console.log(item);
            })
            this.setState({
                isLoading: false,
                tableData: dataTableCreate,
            });
        } catch (error) {
            console.warn(error);
            this.setState({
                isLoading: false,
            });
        }
    };

    // ABRE O MODAL DE EDITAR UM ITEM
    openEditModal = (editItem: AlertInterface) => {
        if (!!editItem.id) // 
            this.openOrEditSelectItem(editItem.id);
        else
            this.setState({ editItem, showFormModal: true })
            console.log('valor do edit modal', this.state.editItem)
    };

    openOrEditSelectItem = (id: string) => {
        const alert = this.getAlertById(id);
        console.log('alert found: ', alert);

        // passa para ser editado
        this.setState({ editItem: alert, showFormModal: true });
    }

    onSubmit = async (input: any, actions: { setSubmitting: Function }) => {
        const { tableData, editItem } = this.state;
        try {
            let nextTableData: any[] = [];
            // EDITTING
            if (!!input.id) {
                if (editItem.imgUrl === input.imgData) {
                    input.imgData = undefined;
                }
                console.log('input : ', input);

                let dataEdit: AlertInterface;
                dataEdit = {
                    id: input.id,
                    name: input.name,
                    text: input.text,
                    duration: input.duration,
                    imgData: this.state.imageUpload
                }
                console.log('data edit to update: ', dataEdit);
                const response: any = await _service.updateById(input.id, dataEdit, this.idUnit);
                console.log('table data before change: ', tableData);

                const targetIndex = findIndex(
                    tableData,
                    (item: AlertInterface) => item.id === response.id,
                );
                nextTableData = tableData;

                if (nextTableData[targetIndex]) {
                    nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
                    console.log('response: ', response);
                    const playAudio = <div>
                        <SampleAudioComponent actionText={"@Tocar"} url={response.audioMaleUrl} />
                        <SampleAudioComponent actionText={"@Tocar"} url={response.audioFemaleUrl} />
                    </div>;
                    nextTableData[targetIndex].audio = playAudio;
                    if (response.imgUrl) nextTableData[targetIndex].photo = response.imgUrl;

                    console.log('next table data: ', nextTableData);

                    const alertIndex = findIndex(this.allAlerts,
                        (item: AlertInterface) => item.id === nextTableData[targetIndex].id);

                    if (this.allAlerts[alertIndex]) {
                        this.allAlerts[alertIndex].imgUrl = nextTableData[targetIndex].photo;
                        this.allAlerts[alertIndex].name = nextTableData[targetIndex].name;
                        this.allAlerts[alertIndex].text = nextTableData[targetIndex].text;
                        this.allAlerts[alertIndex].duration = nextTableData[targetIndex].duration;
                        this.allAlerts[alertIndex].audioFemaleUrl = response.audioFemaleUrl;
                        this.allAlerts[alertIndex].audioMaleUrl = response.audioMaleUrl;
                        console.log(' data: ',  this.allAlerts[alertIndex].imgUrl);
                        if (nextTableData[targetIndex].imgData)
                            this.allAlerts[alertIndex].imgData = nextTableData[targetIndex].imgData;
                    }
                }

            } // CREATING 
            else {

                const data: any = {
                    name: input.name,
                    text: input.text,
                    duration: input.duration,
                    imgData: this.state.imageUpload
                }
                const response: any = await _service.create(data, this.idUnit);
                const playAudio =
                    <div>
                        <SampleAudioComponent actionText={"@Tocar"} url={response.audioMaleUrl} />
                        <SampleAudioComponent actionText={"@Tocar"} url={response.audioFemaleUrl} />
                    </div>;
                const newObj = {
                    id: response.id,
                    name: response.name,
                    text: response.text,
                    photo: response.imgData,
                    duration: response.duration,
                    audio: playAudio,
                };
                nextTableData = [newObj, ...tableData];
            }

            actions.setSubmitting(false);
            this.setState({
                isLoading: false,
                showFormModal: false,
                tableData: nextTableData,
            });

        } catch (error) {
            NotificationComponent.Notify('error', 'Erro ao cadastrar', error);
            const serverResponse = get(error, 'response.data.err');
            if (serverResponse) {
                this.setState({ serverResponse });
            } else {
                console.warn(error, error.status);
            }
        } finally {
            actions.setSubmitting(false);
        }
    };

    // ABRE O MODAL DE DELETAR UM PRODUTO
    deleteAlert = async (id: string) => {
        try {
            // TODO: confirmar com Modal
            const { tableData } = this.state;
            const nextTableData = tableData.filter((item: AlertInterface) => item.id !== id);
            this.setState({
                isLoading: false,
                tableData: nextTableData,
            });

            await _service.deleteById(id, this.idUnit);
        } catch (e) {
            // TODO: mostrar erro com Modal
            console.error(e);
        }
    };

    handleSearch = ({ searchTerm }: { searchTerm: string }) => {
        const { tableData } = this.state;
        const nextTableData = tableData.filter((item: AlertInterface) => {
            //const codeFound = String(item.code).indexOf(searchTerm) > -1;
            const nameFound = String(item.name).indexOf(searchTerm) > -1;
            // return !!nameFound || !!codeFound;
            return !!nameFound;
        });
        this.setState({
            filteredTableData: searchTerm && searchTerm.length > 1 ? nextTableData : tableData,
        });
    };

    getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeUpload = (file: any) => {
        let newFileList: any[] = [];
        newFileList.push(file);
        this.setState({ fileList: newFileList });
        return false;
    }

    onRemoveImageUpload = (file: any) => {
        this.setState({ fileList: [] });
        // this.props.onSubmit(false, '');
    };

    handleChangeImageUpload = async (info: any) => {
        if (info.file) {
            await this.getBase64(info.file, (imageUrl: string) => {
                const imgData = imageUrl.substr(imageUrl.indexOf(',') + 1);
                this.setState({ imageUpload: imgData })
            });
        }
        console.log('valor do image', info.file)

        // this.setState({ fileList })'
    };
    handlePreview = async (file: any) => {
        this.setState({
          previewImage: file.url || file.thumbUrl,
          previewVisible: true,
        });
      }


    render() {
        const {
            isLoading,
            showFormModal,
            showImageModal,
            tableData,
            filteredTableData,
            editItem,
            serverResponse,
        } = this.state;
        // Se está carregando
        if (!!isLoading) {
            return (
                <Page>
                    <AppContext.Consumer>
                        {({ locale, activeUnitId }) => (
                            this.setUnit(activeUnitId),
                            <span>{I18n.l('common.loadingTable')}</span>
                        )}
                    </AppContext.Consumer>
                </Page>
            );
        }
        // Se não está mais carregando
        return (
            <Page>
                <AppContext.Consumer>
                    {({ locale, theme, activeUnitId }) => (
                        this.setUnit(activeUnitId),
                        <Wrapper>
                            <Toolbar>
                                <ToolbarItem>
                                    <RegisterBtnComponent
                                        onClick={this.toggleFormModal}
                                        buttonText={I18n.l('common.register') + " " + I18n.l('labels.alert')}
                                    />
                                </ToolbarItem>
                                <ToolbarItem>
                                    <FormBuilder settings={AlertSearchForm} onSubmit={this.handleSearch} />
                                </ToolbarItem>
                            </Toolbar>
                            {tableData.length > 0 && (
                                <div className={'goepik-component-tablesize'}>
                                    <Table
                                        columns={tableColumns}
                                        data={filteredTableData.length > 0 ? filteredTableData : tableData}
                                        onEdit={this.openEditModal}
                                        onDelete={this.deleteAlert}
                                        noPagination={true}
                                        showConfirmationModal={false}
                                    />
                                </div>
                            )}
                            {tableData.length === 0 && <p>{locale && I18n.l('common.noResult')}</p>}
                            {/* -- Modal DE EDITAR OR CREATE ALERT  -- */}
                            {showFormModal && (
                                <Modal onClose={this.toggleFormModal} isOpen={showFormModal}>
                                    <ModalTitle>{I18n.l('form.titles.alertsForm')}</ModalTitle>
                                    <ModalContent>
                                        <FormBuilder
                                            settings={editItem.id != undefined ? AlertEditForm : AlertForm}
                                            onSubmit={this.onSubmit}
                                            onCancel={this.toggleFormModal}
                                            data={
                                                [
                                                    { name: 'id', value: editItem.id },
                                                    { name: 'name', value: editItem.name },
                                                    { name: 'text', value: editItem.text },
                                                    { name: 'duration', value: editItem.duration },
                                                    { name: 'imgData', value: editItem.imgUrl }
                                                ]}
                                            innerComponent={
                                                <div style={{ marginTop: '15px' }} >
                                                    <p> {I18n.l('form.labels.alerts.image')}</p>
                                                    <Dragger defaultFileList={editItem.imgData} multiple={false} fileList={this.state.fileList} onChange={this.handleChangeImageUpload} beforeUpload={this.beforeUpload} onRemove={this.onRemoveImageUpload}>
                                                        <p className="ant-upload-drag-icon">
                                                            <Icon type="inbox" />
                                                        </p>
                                                        <p className="ant-upload-text">{I18n.l('form.placeholders.photo')}</p>
                                                    </Dragger>
                                                </div>
                                            }
                                        />
                                        {serverResponse && (
                                            <ApiResponseDisplayer theme={theme} locale={locale} data={serverResponse} />
                                        )}
                                    </ModalContent>
                                </Modal>
                            )}
                            {showImageModal && (
                                <Modal onClose={this.toggleShowImage} isOpen={showImageModal}>
                                    <ModalContent>
                                        <ModalImageComponent
                                            urlPath={editItem.imgUrl}
                                            title={'Imagem do alerta: ' + editItem.name}
                                        />
                                    </ModalContent>
                                </Modal>

                            )}
                        </Wrapper>
                    )}
                </AppContext.Consumer>
            </Page>
        );
    }
}

const Wrapper = styled.div`
              display: flex;
              flex-flow: column;
              align-items: flex-start;
              justify-content: flex-start;
              width: 100%;
            `;

const Toolbar = styled.div`
              flex: 0;
              display: flex;
              flex-flow: row nowrap;
              margin-bottom: 40px;
              width: 100%;
            `;

const ToolbarItem = styled.div`
              flex: 1;
              margin-left: 50px;
            
  &:first-of-type {
                    flex: 0;
                margin-left: 0;
              }
            `;

const ModalTitle = styled.h3`
              font-size: 22px;
            `;

const ModalContent = styled.div`
              width: 100%;
            `;

export default Alerts;
